import { JSONSchema7 } from 'json-schema';

const ForwardStepTypeSchema = async () => {
    let schema: JSONSchema7 = {
        title: 'EditedBySimpleTextSchema',
        type: 'object',
        //
        definitions: {},
    };
    //
    schema = {
        properties: {
            className: {
                type: 'string',
            },
            showPayload: {
                type: 'boolean',
            },
        },
        //
        ...schema,
    };
    //
    return schema;
};

export default ForwardStepTypeSchema;
